/**
 * このアプリのヘルプ。文書は隣の `content/<セクション>/<スラッグ>.md` に置く。
 *
 * glob はこのモジュールの位置から解決されるので、集めるのはここで行い、
 * 並びと引き当ては共通パッケージの `createHelpRegistry` に任せる。
 */

import {
  createHelpIcon,
  createHelpPage,
  createHelpRegistry,
  type HelpSectionTitle,
} from "visumo-data-agent-web-shared";

const rawFiles = import.meta.glob("./content/**/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

/**
 * セクションの表示名と並び。ここに無いディレクトリも、末尾にディレクトリ名の
 * まま出る。
 */
export const SECTION_TITLES: readonly HelpSectionTitle[] = Object.freeze([
  { key: "getting-started", title: "はじめに" },
  { key: "products", title: "商品と投稿" },
  { key: "knowledge", title: "商品知識" },
  { key: "video-meta", title: "動画メタ" },
  { key: "personas", title: "ペルソナ" },
  { key: "aio", title: "AIO 対策" },
  { key: "rules", title: "ルール" },
  { key: "publish", title: "公開" },
  { key: "integrations", title: "AI との連携・API" },
  { key: "intake", title: "データの取り込み" },
  { key: "settings", title: "ログイン・権限" },
  { key: "audit", title: "監査ログ" },
  { key: "notifications", title: "通知" },
  { key: "account", title: "会社・招待・代行" },
  { key: "help", title: "ヘルプ" },
]);

export const registry = createHelpRegistry({
  files: rawFiles,
  sectionTitles: SECTION_TITLES,
});

export const HelpIcon = createHelpIcon(registry);

/** 見出しの横に置くものは `pages/HelpPage.tsx` が `extra` で渡す */
export const HelpPage = createHelpPage(registry);
